import { useObserver } from "mobx-react";
import React from "react";
import {
  MdArrowForwardIos,
  MdEmail,
  MdOutlineHomeRepairService,
  MdOutlineInsertDriveFile,
} from "react-icons/md";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";
import { toJS } from "mobx";
import Tooltip from "../reusble_components/tooltip";

const data = [
  { type: "email", name: "React js", applicants: 45, date: "22/07/2024" },
  { type: "email", name: "ui/ux", applicants: 45, date: "22/07/2024" },
  { type: "email", name: "React js", applicants: 45, date: "22/07/2024" },
  { type: "email", name: "ui/ux", applicants: 45, date: "22/07/2024" },
];

export default function RecentActivity() {
  const convertTimestampToDate = (timestamp) => {
    const date = new Date(timestamp); // Convert milliseconds to Date object
    const options = { year: "2-digit", month: "short", day: "2-digit" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };
  const navigate = useNavigate();

  const handleRedirect = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    console.log(toJS(item));
    if (item.type === "jobpost") {
      if (item.applicants < 1) {
        alert("No applicants found");
        return;
      }
      navigate(`/company/job-applicants/${item._id}`);
    }
    if (item.type === "resumeSorting") {
      if (item.applicants < 1) {
        alert("No applicants found");
        return;
      }
      navigate(
        `/company/resumescore/${item._id}${
          item?.isSortingCompleted ? "" : "?save=true"
        }`,
      );
    }
    if (item.type === "interview") {
      if (item.applicants < 1) {
        alert("No applicants found");
        return;
      }
      navigate(`/company/applicants/${item._id}`);
    }
  };

  const { RecuiterStore } = useStores();
  return useObserver(() => (
    <>
      <div
      // className="flex items-center  md:p-3 lg:p-3  bg-white border-t-[0.1px] md:h-[93%] md:w-full lg:md:w-full  w-[90%] mx-auto  md:mt-1 lg:mt-1 border-t-gray-100 rounded-lg justify-center md:overflow-hidden"
      // style={{ boxShadow: "rgb(229 229 229) 0px 0px 60px 5px" }}
      >
        <div
          className=" bg-white md:overflow-y-auto md:overflow-x-hidden  h-full md:ml-0 lg:ml-0 rounded-lg p-2 md:w-full lg:md:w-full w-[93%] mx-auto  md:no-scrollbar md:overscroll-none"
          // style={{ boxShadow: "0px 0px 60px 10px rgba(0, 0, 0, 0.05)" }}
          style={{ boxShadow: "rgb(229 229 229) 0px 0px 60px 5px" }}
        >
          <h2 className="text-lg gil-med ml-2 lg:ml-5 md:ml-3 md:mt-3 lg:mt-3 mt-0 text-gray-800 mb-2 ">
            Recent Activity
          </h2>

          <div className="overflow-auto max-h-[240px] md:mb-2 lg:mb-2 mb-5 lg:ml-3 md:ml-3 ml-0 md:mt-5 lg:mt-5 mt-4 md:w-[95%]">
            <table className="w-full border-collapse ">
              <thead>
                <tr className="bg-gray-100 rounded-lg">
                  <th className="text-center text-xs rounded-l-lg font-medium text-[#000000] p-2 whitespace-nowrap">
                    Type
                  </th>
                  <th className="text-center text-xs font-medium text-[#000000] p-2 whitespace-nowrap">
                    Assessment Name
                  </th>
                  <th className="text-center text-xs font-medium text-[#000000] p-2 whitespace-nowrap">
                    Applicants
                  </th>
                  <th className="text-center hidden md:block text-xs font-medium text-[#000000] p-2 whitespace-nowrap">
                    Posted On
                  </th>
                  <th className="p-2 rounded-r-lg"></th>
                </tr>
              </thead>

              <tbody>
                {RecuiterStore.recentActivity.length === 0 && (
                  <tr>
                    <td colSpan={5} className="p-8 text-center text-primary">
                      No recent activity
                    </td>
                  </tr>
                )}
                {Array.isArray(RecuiterStore.recentActivity) &&
                  RecuiterStore.recentActivity
                    .slice(0, 4)
                    ?.map((item, index) => (
                      <tr
                        key={index}
                        className="border-b  cursor-pointer hover:bg-gray-50"
                        onClick={(e) => handleRedirect(e, item)}
                      >
                        <td className="p-2">
                          <div className="flex items-center justify-center">
                            <div className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center">
                              {item.type === "email" ? (
                                <Tooltip id="email-tooltip" content="Email">
                                  <MdEmail
                                    className="text-gray-500"
                                    size={16}
                                  />
                                </Tooltip>
                              ) : item.type === "resumeSorting" ? (
                                <Tooltip
                                  id="resume-tooltip"
                                  content="Resume Analyzer"
                                >
                                  <MdOutlineInsertDriveFile
                                    className="text-gray-500"
                                    size={16}
                                  />
                                </Tooltip>
                              ) : item.type === "interview" ? (
                                <Tooltip
                                  id="interview-tooltip"
                                  content="Interview"
                                >
                                  <MdOutlineHomeRepairService
                                    className="text-gray-500"
                                    size={16}
                                  />
                                </Tooltip>
                              ) : (
                                <Tooltip id="job-tooltip" content="Job Post">
                                  <MdOutlineHomeRepairService
                                    className="text-gray-500"
                                    size={16}
                                  />
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className="p-2 text-xs text-gray-600 text-center whitespace-nowrap">
                          {item.name}
                        </td>
                        <td className="p-2 text-xs text-gray-600 text-center whitespace-nowrap">
                          {item?.applicants}
                        </td>
                        <td className="p-2 text-xs text-gray-600 text-center hidden md:table-cell">
                          {convertTimestampToDate(item.createdAt)}
                        </td>
                        <td className="text-center">
                          <button
                            className="text-orange-500 hover:text-orange-600"
                            onClick={(e) => handleRedirect(e, item)}
                          >
                            <MdArrowForwardIos size={14} />
                          </button>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  ));
}
